var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{class:_vm.$style.container},_vm._l((_vm.renderList),function(item){return _c('li',{key:item.name,class:[_vm.$style.item, { [_vm.$style.itemDisabled]: item.disabled }],on:{"click":item.handler}},[_c('BaseIcon',{class:_vm.$style.icon,attrs:{"name":item.icon,"custom":item.customIcon}}),_c('div',[_vm._v(_vm._s(item.name))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }